







































import _ from 'lodash'
import { Component, Mixins } from 'vue-property-decorator'
import TcwLayoutBasicTemplate from '@/layout/TcwLayoutBasicTemplate.vue'
import { ArrayDataGetComponent } from '@/tcw/components/DataGetComponent'
import DataUpdateComponent from '@/tcw/components/DataUpdateComponent'
import * as ApiPath from '@/tcw/constant/ApiPath'
import KintaiPatternCard from '@/components/pattern/molecules/KintaiPatternCard.vue'
import { TcwFormID } from '@/tcw/domain/types'
import { TCWServerValidationError } from '@/plugins/TCWBaseError'
import { ApiGeneralObjectArrayPayload } from '@/tcw/api/types'

@Component({
  components: { TcwLayoutBasicTemplate, KintaiPatternCard }
})
export default class KintaiPatternCardList extends Mixins(
  ArrayDataGetComponent,
  DataUpdateComponent
) {
  private patternList: ApiGeneralObjectArrayPayload = []
  private confirm = false
  private deleteId: TcwFormID = null

  get apiPath(): string {
    return ApiPath.Paths.KintaiPatternList.get
  }
  protected responseInitWebApi(response: ApiGeneralObjectArrayPayload): void {
    if (_.isArray(response)) {
      this.patternList = response
    }
  }

  protected addPattern(): void {
    this.$router.push('/pattern/Kintai/')
  }
  protected openConfirm(patternId: TcwFormID): void {
    this.deleteId = patternId
    this.confirm = true
  }

  protected async validate(): Promise<void> {
    if (this.deleteId === null) {
      return Promise.reject('削除する勤怠パターンを選択してください')
    } else {
      return Promise.resolve()
    }
  }

  protected async execSaveMain(): Promise<void> {
    // API 構築
    const apiPath = ApiPath.Paths.KintaiPatternEdit.delete
    const id = this.deleteId ? this.deleteId : ''
    const path = ApiPath.buildPath(apiPath, { id })

    // 削除実行勤怠パターンの削除に失敗しました
    await this.getWebApi().call(path, 'DELETE')
  }

  protected serverValidationErrorProc(e: TCWServerValidationError): void {
    const message = `${e.message}。使用しているパターン：${e.getMessageDetail()}`
    this.$tcw.message({
      type: 'error',
      title: '削除に失敗しました',
      message: message
    })
    console.log(e.invalidInfo)
  }

  protected async afterSaveProc(): Promise<void> {
    this.$tcw.message({
      type: 'success',
      message: '勤怠パターンを削除しました'
    })

    // 再読み込み
    await this.init()
  }
  protected async endProc(): Promise<void> {
    this.confirm = false
  }
}
